import React from "react";
import Dialog from "@material-ui/core/Dialog";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import Button from "../Button/Button";
import { ContentWrapper } from "./ConfirmationDialog.style";
class ConfirmationDialog extends React.Component {
  render() {
    const {
      closeDialog,
      isDialogOpened,
      onDeleteClicked,
      selectedVideoId,
      title,
      message
    } = this.props;

    return (
      <Dialog
        open={isDialogOpened}
        onClose={closeDialog}
        aria-labelledby="responsive-dialog-title"
        maxWidth={false}
      >
        <ContentWrapper>
          <div style={{ padding: "20px 0 0 0", fontSize: "25px" }}>{title}</div>
          <div
            style={{
              padding: "20px 0 0 0",
              color: "gray",
              fontSize: "17px"
            }}
          >
            {message}
          </div>
          <div
            style={{
              display: "flex",
              padding: "20px",
              justifyContent: "center"
            }}
          >
            <Button
              text={this.props.cancleText}
              color="lightGray"
              styles={{ wrapper: { marginRight: "40px" } }}
              onClick={closeDialog}
            />
            <Button
              color="darkGray"
              text={this.props.deleteText}
              onClick={onDeleteClicked(selectedVideoId)}
            />
          </div>
        </ContentWrapper>
      </Dialog>
    );
  }
}

export default withMobileDialog()(ConfirmationDialog);
